// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"e50109fa","372":"67697637","443":"054985d7","738":"256754d3","856":"44579619"}[chunkId] + ".chunk.js";
};